import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ProductService } from '../product.service';
import { FormArray, FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import Swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss']
})
export class NewProductComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  newProductForm: FormGroup;
  // @Input() providers;
  @Input() producttypes;
  @Input() plantypes;
  @Input() providerService;
  @Input() transactionTypes;
  @Input() carrierCountries;
  @Input() carrierTypes;
  @Input() codeGroups;
  @Input() serviceCountries;
  @Input() responseTypes;
  @Input() pricelists;
  providers: any;
  commisionGroup = {}
  commissions: FormArray;
  purchaseDiscountTypevalue;
  disablefield;
  maxvalue;
  constructor(private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private ProductService: ProductService,
    private toastr: ToastrService) {
    super();


    // Provider names
    this.ProductService.getactiveproviders().subscribe(
      res => {
        let _providers: any = res;
        if (_providers.httpcode == 200) {
          this.providers = _providers.data;
          //;
          
        }
      }
    );

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['providers']) {
      this.providers = changes['providers'].currentValue;
      //;
    }
    if (changes['pricelists']) {
      //
      this.pricelists = changes['pricelists'].currentValue;
      if (this.pricelists && this.pricelists) {
        //
        this.commissions.controls = [];
        this.pricelists.forEach(item => {
          
         
          // 
          //
          this.commisionGroup = {};
          this.commisionGroup[item.priceListName] = new FormControl('', Validators.required);

          this.commissions.push(this.fb.group(this.commisionGroup))

        });
        
        
      }
    }




    

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initFrom();
    this.commissions = this.newProductForm.get('commissionInfo') as FormArray;

  }

  initFrom() {
    this.newProductForm = this.fb.group({
      providerName: '',
      productDescription: '',
      productName: '',
      productDropdownName: '',
      productType: '',
      productService: '',
      responseType: '',
      serviceCountry: '',
      sku: '',
      transactionType: '',
      exchangeRate: '',
      codeGroup: '',
      planType: '',
      currency: '',
      carrier: '',
      faceValueMinAmt: '',
      faceValueMaxAmt: '',
      fee: '',
      topupvalueCustomer: '',
      commissionPlan1: '',
      commissionRate1: '',
      commissionPlan2: '',
      commissionRate2: '',
      purchaseDiscount: '',
      purchaseDiscountType: '',
      widelyUsed: '',
      commissionInfo: this.fb.array([]),
      cellPaySKU:'',
      cellPayCarrierId:''
    })
  }

  get f() {
    return this.newProductForm.controls;
  }

  onNewProductSubmit() {
   
    if (this.newProductForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.newProductForm)
        } else {
          this.newProductForm.reset();
          //window.location.reload();
          this.router.navigate(['features/products/all-products'])
        }
      });

    }


  }

  setSubmitParameters(newProductForm: FormGroup) {
    var _commits = new Array();
    var _history = new Array(); 

   
   
    let _updatedcommissionInfo: any = newProductForm.get('commissionInfo').value;
    _updatedcommissionInfo.forEach((value : any, key: any) => {
      _commits.push({priceListName:this.pricelists[key].priceListName,
      priceListValue:value[this.pricelists[key].priceListName],
      priceListType:this.pricelists[key].priceListType,
      priceListValueType:this.newProductForm.get('purchaseDiscountType').value,
      });
      _history.push({priceListName:this.pricelists[key].priceListName,
        currentValue:value[this.pricelists[key].priceListName],
        previousValue:'0',
        columnName:'pricelistValue',
        });
    });
   
    //return;
    //this.updatedcommissionInfo = _updatedcommissionInfo;



    let provider_id = newProductForm.get('providerName');
    let prividerName = this.providers.filter(x => x.providerId = provider_id)[0].providerName;
    if (newProductForm.get('productType').value == 'FIX'){ 
        this.maxvalue = newProductForm.get('faceValueMaxAmt').value;
    }else{
        this.maxvalue = newProductForm.get('faceValueMinAmt').value 
    }
    let formData: Params = {
      productName: newProductForm.get('productName').value,
      productDropdownName: newProductForm.get('productDropdownName').value,
      sku: newProductForm.get('sku').value,
      productType: newProductForm.get('productType').value,
      provider: prividerName,
      carrier: newProductForm.get('carrier').value,
      currency: newProductForm.get('currency').value,
      currencyRate: newProductForm.get('exchangeRate').value,
      faceValueMinAmt: this.maxvalue,
      faceValueMaxAmt: newProductForm.get('faceValueMaxAmt').value,
      fee: newProductForm.get('fee').value,
      carrierService: newProductForm.get('productService').value,
      codeGroup: newProductForm.get('codeGroup').value,
      planType: newProductForm.get('planType').value,
      serviceCountry: newProductForm.get('serviceCountry').value,
      productDescription: newProductForm.get('productDescription').value,
      providerId: newProductForm.get('providerName').value,
      purchaseDiscount: newProductForm.get('purchaseDiscount').value,
      purchaseDiscountType: newProductForm.get('purchaseDiscountType').value,
      responseType: newProductForm.get('responseType').value,
      transactionType: newProductForm.get('transactionType').value,
      widelyUsed: newProductForm.get('widelyUsed').value,
      commissionInfo: [],
      productHistory: [],
      cellPaySKU:newProductForm.get('cellPaySKU').value,
      cellPayCarrierId:newProductForm.get('cellPayCarrierId').value

    };
   
    formData['commissionInfo'] = _commits;
    formData['productHistory'] = _history;


    // JSON.stringify(httpParams)
    this.ProductService.addProduct(formData).subscribe(res => {
      if (res && res) {
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_110") || res.responseStatus == 'Success'){
          this.router.navigate(['features/products/all-products'])
          this.toastr.success('Product added successfully', 'Success', {
            timeOut: 3000,
          });        
      }else if(res.errorCodes && res.errorCodes[0] == "TILA_113"){
        Swal.fire(
          {
            title: res.responseStatus,
            text: res.userMessage,
            icon: 'error',
            timer: 2000
          }
        )
        this.router.navigate(['features/products/all-products'])
      } else {
        Swal.fire(
          {
            title: res.responseStatus,
            text: res.userMessage,
            icon: 'error',
            timer: 2000
          }
        )
        this.router.navigate(['features/products/all-products'])
      }
    }
    });


  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  onCancel() {

    this.newProductForm.reset();
    this.router.navigate(['features/products/all-products'])
    //window.location.reload();
  }
  onproductChange(e){
    if(e.value == 'FIX'){
      this.disablefield = true;
      this.newProductForm.get('faceValueMinAmt').disable();
    }else{
      this.newProductForm.get('faceValueMinAmt').enable();
    }
  }


  numMask(rawValue: string): RegExp[] {
    const mask = /^(?:[0-9]+(?:\.[0-9]{0,2})?)?$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }
}





  // {​​​​​
  // "priceListName": "rate_plan_retailer1_commission",
  // "priceListType": "retailer",
  // "priceListValue": 20,
  // "priceListValueType": "%"
  // }​​​​​,
  // {​​​​​
  // "priceListName": "rate_plan_retailer2_commission",
  // "priceListType": "retailer",
  // "priceListValue": 20,
  // "priceListValueType": "%"
  // }​​​​​,
  // {​​​​​
  // "priceListName": "rate_plan_salesrep1_commission",
  // "priceListType": "retailer",
  // "priceListValue": 20,
  // "priceListValueType": "%"
  // }​​​​​,
  // {​​​​​
  // "priceListName": "rate_plan_salesrep2_commission",
  // "priceListType": "retailer",
  // "priceListValue": 20,
  // "priceListValueType": "%"
  // }​​​​​
  // ],

  // "productHistory": [
  // {​​​​​
  // "priceListName": "rate_plan_salesrep2_commission",
  // "currentValue": 10,
  // "previousValue": 0,
  // "columnName": "pricelistValue"
  // }​​​​​,
  // {​​​​​
  // "priceListName": "rate_plan_salesrep1_commission",
  // "currentValue": 10,
  // "previousValue": 0,
  // "columnName": "pricelistValue"
  // }​​​​​
  // ]


